import { CommonModule, Location } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonNgModule } from '../../shared/modules/common-ng/common-ng.module';
import { PrimeModuleModule } from '../../shared/modules/prime-module/prime-module.module';
import { UiKitModule } from '../../shared/modules/ui-kit/ui-kit.module';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportService } from '../../services/report.service';
import { ConsultaService } from '../../services/consulta.service';

@Component({
  selector: 'app-notificacion-firma-mandato',
  standalone: true,
  imports: [
    CommonModule,
    CommonNgModule,
    UiKitModule,
    PrimeModuleModule
  ],
  providers:[
    ReportService,
    ConsultaService
  ],
  templateUrl: './notificacion-firma-mandato.component.html',
  styleUrl: './notificacion-firma-mandato.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class NotificacionFirmaMandatoComponent implements OnChanges {
  @Input() CodeResult:any; // codigo resultado de firma
  @Input() TypeApp:any; // codigo origen de app TypeApp
  @Input() CurrentRutUser:any; // usuario actual consulta
  @Input() FolioMandato: any;
  @Input() NombreAfiliado: any;

  formData!: FormGroup;
  codeResultFirmaMandato:any;
  submitted: boolean          = false;
  loading: boolean = false;
  contentNotificacion = {
    icon: '',
    title: '',
    body: '',
    accionBtn: '',
    context:''
  }
  origen:any;
  emailSuccess:boolean = false;
  labelEmailSuccess:any = '';
  disabledSendEmail:boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private fb: FormBuilder,
    private readonly reportService: ReportService,
    private readonly consultaService: ConsultaService
  ){
    // this.activatedRoute.queryParams
    // .subscribe(params => {
    //   this.codeResultFirmaMandato = params['result'];
    //   this.codeResultFirmaMandato = params['code'];
    //   console.log('params', this.codeResultFirmaMandato);
    //     if((this.codeResultFirmaMandato != '0') && (this.codeResultFirmaMandato != '1')) {
    //       console.log('this.codeResultFirmaMandato', this.codeResultFirmaMandato);
    //       this.router.navigate( ['/']);
    //       // this._location.back();
          
    //     }
    //     this.setNotificacion(this.codeResultFirmaMandato);
    // })

    this.formData = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    // alert('view notificacion');
  }

  

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('componente notificacion:', {
    //   'CodeResult': this.CodeResult,
    //   'TypeApp': this.TypeApp,
    //   'CurrentRutUser': this.CurrentRutUser,
    // });

    this.setNotificacion(this.CodeResult);
    
  }

  get f() { return this.formData.controls; }

  setNotificacion(codeResult:any){
    if (codeResult === 0) {
      this.contentNotificacion.icon = './assets/img/ico_check_ok.svg';
      this.contentNotificacion.title = '<h2>¡Felicidades!<br/> Activaste exitosamente tu beneficio</h2>';
      this.contentNotificacion.body = '<h3>Gracias por completar el proceso de activación del beneficio de condonación de intereses y recargos.</h3><p>Tu comprobante ya está disponible.<br/> Elige cómo deseas recibirlo:</p>';
      this.contentNotificacion.accionBtn = 'Descarga documento';
      this.contentNotificacion.context = '0';
    }

    if (codeResult === 1) {
      this.contentNotificacion.icon = './assets/img/ico_error_notificacion.svg';
      this.contentNotificacion.title = '<h2>¡Ups!<br/> Algo falló</h2>';
      this.contentNotificacion.body = '<h3>Lamentamos el inconveniente.</h3><p>Hubo un problema al intentar procesar tu firma digital. Te sugerimos verificar tu conexión a internet o intentarlo más tarde.</p>';
      this.contentNotificacion.accionBtn = 'Intentar otra vez';
      this.contentNotificacion.context = '1';
    }

    if (codeResult === 2) {
      this.contentNotificacion.icon = './assets/img/ico_check_ok.svg';
      this.contentNotificacion.title = '<h2>Tu beneficio ya se encuentra activo</h2>';
      this.contentNotificacion.body = '<h3>El beneficio de condonación de intereses y recargos ya está activo.</h3><p>Puedes obtener nuevamente el comprobante.<br/> <br/>Elige cómo deseas recibirlo:</p>';
      this.contentNotificacion.accionBtn = 'Descarga documento';
      this.contentNotificacion.context = '0';
    }
    
    // setTimeout(() => {
    //   this.router.navigate( ['/']);    
    // }, 13000000);
  }

  descargar(context:any){
    if(context === '0'){
      // pegarle al servicio de descargar documento
      // alert('accion btn success');
      this.downloadCartola();
    }
    if (context === '1') {
      //alert('accion btn error');
      this._location.back();
    }
    
  }

  downloadCartola(){
    // alert('Descarga cartola.');
    // console.log('downloadCartola', this.TypeApp);
    // console.log('this.CurrentRutUser typo', typeof this.TypeApp);
    // SA = SITIO PRIVADO
    // SI = CONSULTA INTEGRAL
    // SP = SITIO PUBLICO
    // SM = APP MOVIL
    switch (this.TypeApp) {
      case '0':
        this.origen = 'SA';
      break;
      case '1':
        this.origen = 'SP';
      break;
      case '2':
        this.origen = 'SM';
      break;
      case '3':
        this.origen = 'SI';
      break;
    }

    // console.log('downloadFile', {
    //   'this.CurrentRutUser': this.CurrentRutUser,
    //   'this.origen': this.origen
    // });
    // alert('descargar documento');
    this.reportService.downloadFile('CompensaIngresaMandato', 'CompensaIngresaMandato', 'pdf', {
      "RUT_AFILIADO": this.CurrentRutUser,
      "FOLIO": this.FolioMandato
    } );

  }

  enviarEmail(){
    
    this.submitted = true;
    const payload = {
      rut: this.CurrentRutUser,
      email: this.formData.controls['email'].value,
      folio: this.FolioMandato,
      nombreAfiliado: this.NombreAfiliado
    };
    // console.log('enviar correo', payload);
    if (this.formData.valid) {
      this.loading = true;
      this.consultaService.envioCorreoCompensacion(payload).subscribe( (respEmail:any) => {
        if(respEmail.codigoRetorno == 0) {
          this.labelEmailSuccess = 'Email enviado con éxito.';
          this.disabledSendEmail = true;
        }else if(respEmail.codigoRetorno != 0) {
          this.labelEmailSuccess = 'No se pudo enviar el email. Inténtalo nuevamente.';
          this.disabledSendEmail = false;
        }
        this.emailSuccess = true;

        this.loading = false;
      });
    }
  }


}

